// Configurações centralizadas da aplicação
export const API_CONFIG = {
  // URL base da API/GraphQL - considerar múltiplas variáveis por compatibilidade
  BASE_URL:
    (import.meta.env.VITE_GRAPHQL_API_URL as string | undefined) ||
    (import.meta.env.VITE_APP_API_URL as string | undefined) ||
    (import.meta.env.VITE_API_URL as string | undefined),

  // Timeout padrão para requisições (em milissegundos)
  TIMEOUT: 10000,

  // Headers padrão
  DEFAULT_HEADERS: {
    "Content-Type": "application/json",
  },
} as const;

// Função helper para construir URLs completas da API GraphQL
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl =
    (import.meta.env.VITE_GRAPHQL_API_URL as string | undefined) || ""
  const normalizedBase = baseUrl.replace(/\/+$/, "");
  const cleanEndpoint = endpoint.replace(/^\//, "");
  return `${normalizedBase}/${cleanEndpoint}`;
};

// Função helper para construir URLs REST (sem /graphql)
// Útil para endpoints como /api/arquivo/upload
export const buildRestApiUrl = (endpoint: string): string => {
  const baseUrl =
    (import.meta.env.VITE_GRAPHQL_API_URL as string | undefined) || "";
  // Remove /graphql do final da URL base para obter a URL raiz
  const normalizedBase = baseUrl.replace(/\/graphql\/?$/, "").replace(/\/+$/, "");
  const cleanEndpoint = endpoint.replace(/^\//, "");
  return `${normalizedBase}/${cleanEndpoint}`;
};

export const buildLoginApiUrl = (endpoint: string): string => {
  const baseUrl =
    (import.meta.env.VITE_LOGIN_API_URL as string | undefined) ||
    (import.meta.env.VITE_API_URL as string | undefined) ||
    "";

  const normalizedBase = baseUrl.replace(/\/+$/, "");
  const cleanEndpoint = endpoint.replace(/^\//, "");
  return `${normalizedBase}/${cleanEndpoint}`;
};

// Função helper para obter headers com autenticação
export const getAuthHeaders = (token: string) => ({
  ...API_CONFIG.DEFAULT_HEADERS,
  Authorization: `Bearer ${token}`,
});
